import { Element, h } from './element';
import { cssPrefix } from '../config';

export default class Icon extends Element {
  constructor(name, prefix = '-icon-img') {
    super('div', `${cssPrefix}-icon`);
    this.iconNameEl = h('div', `${cssPrefix}${prefix} ${name}`);
    this.child(this.iconNameEl); 
  }

  setName(name, prefix = '-icon-img') {
    this.iconNameEl.className(`${cssPrefix}${prefix} ${name}`);
  }
}
